/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'fullscreenclose': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M21.75 34.129l-2.518-2.518-4.127 4.126a.359.359 0 0 1-.498-.001l-2.418-2.42a.355.355 0 0 1 0-.496l4.127-4.125-2.519-2.519c-.133-.133-.086-.266.102-.289l8.99-1.146c.188-.023.32.111.297.299l-1.144 8.988c-.026.187-.159.235-.292.101zm4.209-20.156l-1.145 8.988c-.023.188.109.322.297.299l8.99-1.146c.188-.024.234-.156.102-.289l-2.52-2.519 4.127-4.125a.355.355 0 0 0 0-.496l-2.418-2.42a.359.359 0 0 0-.498 0l-4.127 4.125-2.518-2.518c-.132-.134-.265-.087-.29.101z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/fullscreenclose.js